/*
Author: Liubo
Date: 2018-09-05
Desc: 框架配置文件
*/
const conf = {
    views: {
        login: {
            components: [
                {
                    code: "login",
                    name: "登录表单",
                    component: () =>
                        // import(/* webpackChunkName: "login" */ "@/views/common/login.vue")
                        import(/* webpackChunkName: "login" */ "@/views/common/login2.vue")
                }
            ]
        },
        register: {
            components: [
                {
                    code: "reg",
                    name: "注册表单",
                    component: () =>
                        import(
                            /* webpackChunkName: "register" */ "@/bizcomponents/beforeLogin/registerDc.vue"
                        ),
                    option: '{"className": "bizcomp-border"}'
                }
            ]
        },
        resetpwdway: {
            components: [
                {
                    code: "resetpwdway",
                    name: "忘记密码",
                    component: () =>
                        import(
                            /* webpackChunkName: "resetpwdway" */ "@/bizcomponents/beforeLogin/resetLoginDc.vue"
                        ),
                    option: '{"className": "bizcomp-border"}'
                }
            ]
        },
        resetlogin: {
            components: [
                {
                    code: "resetlogin",
                    name: "重置登录密码",
                    component: () =>
                        import(
                            /* webpackChunkName: "resetlogin" */ "@/bizcomponents/beforeLogin/resetLoginDc.vue"
                        ),
                    option: '{"className": "bizcomp-border"}'
                }
            ]
        },
        retrievepwd: {
            components: [
                {
                    code: "retrievepwd",
                    name: "找回密码",
                    component: () =>
                        import(
                            /* webpackChunkName: "resetlogin" */ "@/bizcomponents/beforeLogin/retrievepwd.vue"
                        ),
                    option: '{"className": "bizcomp-border"}'
                }
            ]
        },
        resetrade: {
            components: [
                {
                    code: "resetrade",
                    name: "重置交易密码",
                    component: () =>
                        import(
                            /* webpackChunkName: "resetrade" */ "@/bizcomponents/beforeLogin/resetTradeDc.vue"
                        ),
                    option: '{"className": "bizcomp-border"}'
                }
            ]
        },
        tradepwd: {
            components: [
                {
                    code: "tradepwd",
                    name: "重置交易密码",
                    component: () =>
                        import(
                            /* webpackChunkName: "tradepwd" */ "@/bizcomponents/beforeLogin/resetTradeDc.vue"
                        ),
                    option: '{"className": "bizcomp-border"}'
                }
            ]
        },
        home: {
            components: [
                {
                    code: "assetTotal",
                    name: "资产总览",
                    component: () =>
                        import(
                            /* webpackChunkName: "home" */ "@/bizcomponents/assetShow/assetsTotal.vue"
                        ),
                    option: '{"className": "bizcomp-border"}'
                }
            ]
            // components: [
            //     {
            //         code: "info",
            //         name: "用户信息",
            //         component: () =>
            //             import ( /* webpackChunkName: "home" */ "@/bizcomponents/acctManager/welcome.vue"),
            //         option: "{\"className\": \"bizcomp-border\"}"
            //     },
            //     {
            //         code: "assetShow",
            //         name: "资产信息",
            //         component: () =>
            //             import ( /* webpackChunkName: "home" */ "@/bizcomponents/assetShow/assetsInfo.vue"),
            //         option: "{\"className\": \"bizcomp-border\"}"
            //     },
            //     {
            //         code: "lists",
            //         name: "基金列表",
            //         component: () =>
            //             import ( /* webpackChunkName: "home" */ "@/bizcomponents/assetShow/assetsList.vue"),
            //         option: "{\"className\": \"bizcomp-border\"}"
            //     }
            // ]
        },
        financialManagement: {
            components: [
                {
                    code: "financialManagement",
                    name: "资产总览",
                    component: () =>
                        import(
                            /* webpackChunkName: "home" */ "@/bizcomponents/financialManagement/assetsTotal.vue"
                        ),
                    option: '{"className": "bizcomp-border"}'
                }
            ]
        },
        fundFanagementList: {
            components: [
                {
                    code: "fundFanagementList",
                    name: "产品列表",
                    component: () =>
                        import(
                            /* webpackChunkName: "home" */ "@/bizcomponents/financialManagement/handPickFund.vue"
                        ),
                    option: '{"className": "bizcomp-border"}'
                }
            ]
        },
        fundNotice: {
            components: [
                {
                    code: "fundNotice",
                    name: "产品公告",
                    component: () =>
                        import(
                            /* webpackChunkName: "home" */ "@/bizcomponents/financialManagement/fundNotice.vue"
                        ),
                    option: '{"className": "bizcomp-border"}'
                }
            ]
        },
        fundNav: {
            components: [
                {
                    code: "fundNav",
                    name: "产品净值",
                    component: () =>
                        import(
                            /* webpackChunkName: "home" */ "@/bizcomponents/financialManagement/fundNav.vue"
                        ),
                    option: '{"className": "bizcomp-border"}'
                }
            ]
        },
        assetsDetail: {
            components: [
                {
                    code: "assetsDetail",
                    name: "持仓详情",
                    component: () =>
                        import(
                            /* webpackChunkName: "assetsDetail" */ "@/bizcomponents/assetShow/assetsDetail.vue"
                        ),
                    option: '{"title":"持仓详情","className": "bizcomp-border"}'
                }
            ]
        },
        warnList: {
            components: [
                {
                    code: "warnList",
                    name: "适当性处理",
                    component: () =>
                        import(
                            /* webpackChunkName: "assetsDetail" */ "@/bizcomponents/assetShow/warnList.vue"
                        ),
                    option: '{"title":"适当性处理","className": "bizcomp-border"}'
                }
            ]
        },
        comboAssetsDetail: {
            components: [
                {
                    code: "comboAssetsDetail",
                    name: "持仓情况",
                    component: () =>
                        import(
                            /* webpackChunkName: "assetsDetail" */ "@/bizcomponents/assetShow/comboAssetsDetail.vue"
                        ),
                    option: '{"title":"持仓情况","className": "bizcomp-border"}'
                }
            ]
        },
        moneybox: {
            components: [
                {
                    code: "moneyBox",
                    name: "现金宝",
                    component: () =>
                        import(
                            /* webpackChunkName: "moneybox" */ "@/bizcomponents/moneyBox/moneyBoxDc.vue"
                        ),
                    option: '{"className": "bizcomp-border"}'
                }
            ]
        },
        autoaccess: {
            components: [
                {
                    code: "autoaccess",
                    name: "自动存取款",
                    component: () =>
                        import(
                            /* webpackChunkName: "autoaccess" */ "@/bizcomponents/moneyBox/automaticAccess.vue"
                        ),
                    option: '{"className": "bizcomp-border"}'
                }
            ]
        },
        currencyfund: {
            components: [
                {
                    code: "currencyRate",
                    name: "现金宝七日年化收益率",
                    component: () =>
                        import(
                            /* webpackChunkName: "currencyfund" */ "@/bizcomponents/currencyFund/currencyRate.vue"
                        ),
                    option: '{"className": "bizcomp-border"}'
                },
                {
                    code: "currencyChart",
                    name: "现金宝折线图",
                    component: () =>
                        import(
                            /* webpackChunkName: "currencyfund" */ "@/bizcomponents/currencyFund/currencyChart.vue"
                        ),
                    option: '{"title":"现金宝折线图","charCate":true,"className": "bizcomp-border"}'
                },
                {
                    code: "currencyAdvantage",
                    name: "现金宝优点",
                    component: () =>
                        import(
                            /* webpackChunkName: "currencyfund" */ "@/bizcomponents/currencyFund/currencyAdvantage.vue"
                        ),
                    option: '{"title":"现金宝优点","className": "bizcomp-border"}'
                },
                {
                    code: "currencyInfo",
                    name: "现金宝购买信息",
                    component: () =>
                        import(
                            /* webpackChunkName: "currencyfund" */ "@/bizcomponents/currencyFund/currencyInfo.vue"
                        ),
                    option: '{"className": "bizcomp-border"}'
                },
                {
                    code: "currencyExplanation",
                    name: "热门问题",
                    component: () =>
                        import(
                            /* webpackChunkName: "currencyfund" */ "@/bizcomponents/currencyFund/currencyExplanation.vue"
                        ),
                    option: '{"title":"热门问题","className": "bizcomp-border"}'
                }
            ]
        },
        infoPublish: {
            components: [
                {
                    code: "infoPublish",
                    name: "信息披露",
                    component: () =>
                        import(
                            /* webpackChunkName: "infoPublish" */ "@/bizcomponents/fund/infoPublish.vue"
                        ),
                    option: '{"title":"信息披露","className": "bizcomp-border"}'
                }
            ]
        },
        knowdetail: {
            components: [
                {
                    code: "knowdetail",
                    name: "公告详情",
                    component: () =>
                        import(
                            /* webpackChunkName: "knowdetail" */ "@/bizcomponents/fund/knowdetail.vue"
                        ),
                    option: '{"title":"公告详情","className": "bizcomp-border"}'
                }
            ]
        },
        mycurrency: {
            components: [
                {
                    code: "currencyAssets",
                    name: "现金宝信息",
                    component: () =>
                        import(
                            /* webpackChunkName: "mycurrency" */ "@/bizcomponents/currencyFund/currencyAssets.vue"
                        ),
                    option: '{"title":"我的现金宝","className": "bizcomp-border"}'
                },
                {
                    code: "currencyHold",
                    name: "现金宝持有明细",
                    component: () =>
                        import(
                            /* webpackChunkName: "mycurrency" */ "@/bizcomponents/currencyFund/currencyHold.vue"
                        ),
                    option: '{"title":"持有明细","className": "bizcomp-border"}'
                },
                {
                    code: "currencyIncome",
                    name: "现金宝收益明细",
                    component: () =>
                        import(
                            /* webpackChunkName: "mycurrency" */ "@/bizcomponents/currencyFund/currencyIncome.vue"
                        ),
                    option: '{"title":"收益明细","className": "bizcomp-border"}'
                }
            ]
        },
        currencycharge: {
            components: [
                {
                    code: "currencycharge",
                    name: "现金宝充值",
                    component: () =>
                        import(
                            /* webpackChunkName: "currencycharge" */ "@/bizcomponents/moneyBox/currencyCharge.vue"
                        ),
                    option: '{"title":"现金宝充值","className": "bizcomp-border"}'
                }
            ]
        },
        currencyredemption: {
            components: [
                {
                    code: "currencyredemption",
                    name: "现金宝取现",
                    component: () =>
                        import(
                            /* webpackChunkName: "currencyredemption" */ "@/bizcomponents/moneyBox/currencyRedemption.vue"
                        ),
                    option: '{"title":"现金宝取现","className": "bizcomp-border"}'
                }
            ]
        },
        currencyplan: {
            components: [
                {
                    code: "currencyplan",
                    name: "现金宝定期充值",
                    component: () =>
                        import(
                            /* webpackChunkName: "currencyplan" */ "@/bizcomponents/moneyBox/moneyIn.vue"
                        ),
                    option: '{"title":"现金宝定期充值","className": "bizcomp-border"}'
                }
            ]
        },
        autoextractor: {
            components: [
                {
                    code: "autoextractor",
                    name: "现金宝定期取出",
                    component: () =>
                        import(
                            /* webpackChunkName: "autoextractor" */ "@/bizcomponents/moneyBox/moneyOut.vue"
                        ),
                    option: '{"title":"现金宝定期取出","className": "bizcomp-border"}'
                }
            ]
        },
        securitycenter: {
            components: [
                {
                    code: "securitycenter",
                    name: "安全中心",
                    component: () =>
                        import(
                            /* webpackChunkName: "securitycenter" */ "@/bizcomponents/acctManager/securityCenter.vue"
                        ),
                    option: '{"title":"安全中心","className": "bizcomp-border"}'
                }
            ]
        },
        info: {
            components: [
                {
                    code: "acctinfo",
                    name: "用户信息",
                    component: () =>
                        import(
                            /* webpackChunkName: "info" */ "@/bizcomponents/acctManager/acctInfo.vue"
                        ),
                    option: '{"className": "bizcomp-border"}'
                },
                {
                    code: "holdbank",
                    name: "我的银行卡",
                    component: () =>
                        import(/* webpackChunkName: "info" */ "@/bizcomponents/bank/holdBank.vue"),
                    option: '{"title":"我的银行卡","className": "bizcomp-border"}'
                },
                {
                    code: "personinfo",
                    name: "我的个人资料",
                    component: () =>
                        import(
                            /* webpackChunkName: "info" */ "@/bizcomponents/acctManager/securityCenter.vue"
                        ),
                    option: '{"title":"我的个人资料","className": "bizcomp-border"}'
                }
            ]
        },
        risk: {
            components: [
                {
                    code: "risk",
                    name: "风险测评",
                    component: () =>
                        import(
                            /* webpackChunkName: "risk" */ "@/bizcomponents/acctManager/riskDc.vue"
                        ),
                    option: '{"title":"风险测评","className": "bizcomp-border"}'
                }
            ]
        },
        risktest: {
            components: [
                {
                    code: "risktest",
                    name: "风险测评试题",
                    component: () =>
                        import(
                            /* webpackChunkName: "risktest" */ "@/bizcomponents/acctManager/riskTestDc.vue"
                        ),
                    option: '{"title":"风险测评试题","className": "bizcomp-border"}'
                }
            ]
        },
        infocollection: {
            components: [
                {
                    code: "infocollection",
                    name: "投资者信息补录",
                    component: () =>
                        import(
                            /* webpackChunkName: "infocollection" */ "@/bizcomponents/appropriatenes/infoCollectionDc.vue"
                        ),
                    option: '{"title":"投资者信息补录","className": "bizcomp-border"}'
                }
            ]
        },
        service: {
            components: [
                {
                    code: "service",
                    name: "服务定制",
                    component: () =>
                        import(
                            /* webpackChunkName: "service" */ "@/bizcomponents/acctManager/serviceMenu.vue"
                        ),
                    option: '{"title":"服务定制","className": "bizcomp-border"}'
                }
            ]
        },
        statement: {
            components: [
                {
                    code: "statement",
                    name: "对账单信息",
                    component: () =>
                        import(
                            /* webpackChunkName: "statement" */ "@/bizcomponents/acctManager/statementDc.vue"
                        ),
                    option: '{"title":"对账单信息","className": "bizcomp-border"}'
                }
            ]
        },
        taxeslist: {
            components: [
                {
                    code: "taxeslist",
                    name: "CRS信息",
                    component: () =>
                        import(
                            /* webpackChunkName: "taxes" */ "@/bizcomponents/appropriatenes/taxesList.vue"
                        ),
                    option: '{"title":"税收身份声明","className": "bizcomp-border"}'
                }
            ]
        },
        taxesinfo: {
            components: [
                {
                    code: "taxesinfo",
                    name: "个人税收居民身份声明",
                    component: () =>
                        import(
                            /* webpackChunkName: "taxes" */ "@/bizcomponents/appropriatenes/taxesInfo.vue"
                        ),
                    option: '{"title":"修改税收身份","className": "bizcomp-border"}'
                }
            ]
        },
        policyAndLaw: {
            components: [
                {
                    code: "policyAndLaw",
                    name: "政策法规",
                    component: () =>
                        import(
                            /* webpackChunkName: "policyAndLaw" */ "@/bizcomponents/policyAndLaw/policyAndLaw.vue"
                        ),
                    option: '{"title":"政策法规","className": "bizcomp-border"}'
                }
            ]
        },
        acctManager: {
            components: [
                {
                    code: "acctManager",
                    name: "账户管理",
                    component: () =>
                        import(
                            /* webpackChunkName: "acctManagerDc" */ "@/bizcomponents/acctManager/acctManagerDc.vue"
                        ),
                    option: '{"title":"政策法规","className": "bizcomp-border"}'
                }
            ]
        },
        invchange: {
            components: [
                {
                    code: "invchange",
                    name: "投资者类型转换",
                    component: () =>
                        import(
                            /* webpackChunkName: "invchange" */ "@/bizcomponents/appropriatenes/invChangeDc.vue"
                        ),
                    option: '{"title":"投资者类型转换","className": "bizcomp-border"}'
                }
            ]
        },
        invdetail: {
            components: [
                {
                    code: "invdetail",
                    name: "投资者类型转换",
                    component: () =>
                        import(
                            /* webpackChunkName: "invchange" */ "@/bizcomponents/appropriatenes/invDetail.vue"
                        ),
                    option: '{"title":"投资者类型转换","className": "bizcomp-border"}'
                }
            ]
        },

        infoCollection: {
            components: [
                {
                    code: "infoCollection",
                    name: "投资者信息补录",
                    component: () =>
                        import(
                            /* webpackChunkName: "infoCollection" */ "@/bizcomponents/appropriatenes/infoCollection.vue"
                        ),
                    option: '{"title":"投资者信息补录","className": "bizcomp-border"}'
                }
            ]
        },
        invknowledgetest: {
            components: [
                {
                    code: "invknowledgetest",
                    name: "投资者知识评测",
                    component: () =>
                        import(
                            /* webpackChunkName: "invchange" */ "@/bizcomponents/appropriatenes/invKnowledgeTest.vue"
                        )
                }
            ]
        },
        invdataup: {
            components: [
                {
                    code: "invdataup",
                    name: "投资者转换资料上传",
                    component: () =>
                        import(
                            /* webpackChunkName: "invchange" */ "@/bizcomponents/appropriatenes/invDataUpDc.vue"
                        ),
                    option: '{"title":"投资者转换","className": "bizcomp-border"}'
                }
            ]
        },
        checkacct: {
            components: [
                {
                    code: "checkacct",
                    name: "完善用户信息",
                    component: () =>
                        import(
                            /* webpackChunkName: "checkacct" */ "@/bizcomponents/acctManager/checkAcct.vue"
                        ),
                    option: '{"title":"完善用户信息","className": "bizcomp-border"}'
                }
            ]
        },
        modifyinfo: {
            components: [
                {
                    code: "modifyinfo",
                    name: "个人信息",
                    component: () =>
                        import(
                            /* webpackChunkName: "modifyinfo" */ "@/bizcomponents/acctManager/modifyInfoDc.vue"
                        ),
                    option: '{"title":"个人信息","className": "bizcomp-border"}'
                }
            ]
        },
        ocrinfoupd: {
            components: [
                {
                    code: "ocrinfoupd",
                    name: "更新证件信息",
                    component: () =>
                        import(
                            /* webpackChunkName: "dynaView" */ /* webpackChunkName: "ocrinfoupd" */ "@/bizcomponents/acctManager/ocrInfoUpd.vue"
                        ),
                    option: '{"title":"更新证件信息","className": "bizcomp-border"}'
                }
            ]
        },
        acctinfologin: {
            components: [
                {
                    code: "acctinfologin",
                    name: "账户登录记录",
                    component: () =>
                        import(
                            /* webpackChunkName: "acctinfologin" */ "@/bizcomponents/acctManager/acctInfoLogin.vue"
                        ),
                    option: '{"title":"账户登录记录","className": "bizcomp-border"}'
                }
            ]
        },
        acctinfopwdmodify: {
            components: [
                {
                    code: "acctinfopwdmodify",
                    name: "密码修改记录",
                    component: () =>
                        import(
                            /* webpackChunkName: "acctinfopwdmodify" */ "@/bizcomponents/acctManager/acctInfoPwdModify.vue"
                        ),
                    option: '{"title":"密码修改记录","className": "bizcomp-border"}'
                }
            ]
        },
        wxbindchange: {
            components: [
                {
                    code: "wxbindchange",
                    name: "绑定/解绑微信",
                    component: () =>
                        import(
                            /* webpackChunkName: "dynaView" */ /* webpackChunkName: "wxbindchange" */ "@/bizcomponents/wxBindChange/wxBindChange.vue"
                        ),
                    option: '{"title":"绑定/解绑微信","className": "bizcomp-border"}'
                }
            ]
        },
        remitinfo: {
            components: [
                {
                    code: "remitinfo",
                    name: "汇款地址信息",
                    component: () =>
                        import(
                            /* webpackChunkName: "dynaView" */ /* webpackChunkName: "remitinfo" */ "@/bizcomponents/acctManager/remitInfo.vue"
                        ),
                    option: '{"title":"汇款地址信息","className": "bizcomp-border"}'
                }
            ]
        },
        // privatefundList: {
        //     components: [
        //         {
        //             code: "privatefundList",
        //             name: "高端理财专区",
        //             component: () =>
        //                 import ( /* webpackChunkName: "fundmarket" */ "@/bizcomponents/fund/fundMarket.vue"),
        //             option: "{\"title\":\"高端理财专区\",\"className\": \"bizcomp-border\"}"
        //         }
        //     ]
        // },
        fund: {
            components: [
                // {
                //     code: "hotfund",
                //     name: "热门基金",
                //     component: () =>
                //         import ( /* webpackChunkName: "hotfund" */ "@/bizcomponents/fund/hotFund.vue"),
                //     option: "{\"title\":\"热门基金\",\"className\": \"bizcomp-border\"}"
                // },
                {
                    code: "fundmarket",
                    name: "基金超市",
                    component: () =>
                        import(
                            /* webpackChunkName: "fundmarket" */ "@/bizcomponents/fund/handPickFund.vue"
                        ),
                    option: '{"title":"基金超市","className": "bizcomp-border"}'
                }
            ]
        },
        cfund: {
            components: [
                {
                    code: "cfund",
                    name: "基金转换",
                    component: () =>
                        import(
                            /* webpackChunkName: "cfund" */ "@/bizcomponents/fund/changeFundList.vue"
                        ),
                    option: '{"title":"基金转换","className": "bizcomp-border"}'
                }
            ]
        },
        orderfund: {
            components: [
                {
                    code: "orderfund",
                    name: "预约基金列表",
                    component: () =>
                        import(
                            /* webpackChunkName: "orderfund" */ "@/bizcomponents/fund/orderfund.vue"
                        ),
                    option: '{"title":"预约购买","className": "bizcomp-border"}'
                }
            ]
        },
        orderbuyfund: {
            components: [
                {
                    code: "orderbuyfund",
                    name: "预约购买",
                    component: () =>
                        import(
                            /* webpackChunkName: "orderbuyfund" */ "@/bizcomponents/fund/orderBuyFund.vue"
                        ),
                    option: '{"title":"预约购买","className": "bizcomp-border"}'
                }
            ]
        },
        myorder: {
            components: [
                {
                    code: "myorder",
                    name: "我的预约",
                    component: () =>
                        import(
                            /* webpackChunkName: "myorder" */ "@/bizcomponents/fund/myOrder.vue"
                        ),
                    option: '{"title":"我的预约","className": "bizcomp-border"}'
                }
            ]
        },
        orderselllist: {
            components: [
                {
                    code: "orderselllist",
                    name: "预约赎回列表",
                    component: () =>
                        import(
                            /* webpackChunkName: "myorder" */ "@/bizcomponents/fund/orderSellList.vue"
                        ),
                    option: '{"title":"预约赎回列表","className": "bizcomp-border"}'
                }
            ]
        },
        ordersell: {
            components: [
                {
                    code: "ordersell",
                    name: "预约赎回",
                    component: () =>
                        import(
                            /* webpackChunkName: "ordersell" */ "@/bizcomponents/fund/orderSellFund.vue"
                        ),
                    option: '{"title":"预约赎回","className": "bizcomp-border"}'
                }
            ]
        },
        oldCombofund: {
            components: [
                {
                    code: "oldCombofund",
                    name: "推荐组合购买",
                    component: () =>
                        import(
                            /* webpackChunkName: "combofund" */ "@/bizcomponents/comboBuy/oldCombofund.vue"
                        ),
                    option: '{"title":"推荐组合购买","className": "bizcomp-border"}'
                }
            ]
        },
        optionalfund: {
            components: [
                {
                    code: "optionalfund",
                    name: "自选组合购买",
                    component: () =>
                        import(
                            /* webpackChunkName: "optionalfund" */ "@/bizcomponents/comboBuy/optionalFund.vue"
                        ),
                    option: '{"title":"自选组合购买","className": "bizcomp-border"}'
                }
            ]
        },
        buyfund: {
            components: [
                {
                    code: "buyfund",
                    name: "基金购买",
                    component: () =>
                        import(
                            /* webpackChunkName: "buyfund" */ "@/bizcomponents/fund/buyFund.vue"
                        ),
                    option: '{"title":"基金购买","className": "bizcomp-border"}'
                }
            ]
        },
        sellfund: {
            components: [
                {
                    code: "sellfund",
                    name: "基金赎回",
                    component: () =>
                        import(
                            /* webpackChunkName: "sellfund" */ "@/bizcomponents/fund/sellFund.vue"
                        ),
                    option: '{"title":"基金赎回","className": "bizcomp-border"}'
                }
            ]
        },
        changefund: {
            components: [
                {
                    code: "changefund",
                    name: "基金转换",
                    component: () =>
                        import(
                            /* webpackChunkName: "changefund" */ "@/bizcomponents/fund/changeFundDc.vue"
                        ),
                    option: '{"title":"转换详情","className": "bizcomp-border"}'
                }
            ]
        },
        sellBuyFund: {
            components: [
                {
                    code: "sellBuyFund",
                    name: "赎回转申购",
                    component: () =>
                        import(
                            /* webpackChunkName: "changefund" */ "@/bizcomponents/fund/changeFundDc.vue"
                        ),
                    option: '{"title":"赎回转申购详情","className": "bizcomp-border"}'
                }
            ]
        },
        trusteeshipFund: {
            components: [
                {
                    code: "trusteeshipFund",
                    name: "跨系统转托管详情",
                    component: () =>
                        import(
                            /* webpackChunkName: "changefund" */ "@/bizcomponents/fund/trusteeshipFund.vue"
                        ),
                    option: '{"title":"跨系统转托管详情","className": "bizcomp-border"}'
                }
            ]
        },
        transferCombTrusteeIn: {
            components: [
                {
                    code: "trusteeshipFund",
                    name: "转托管入直销详情",
                    component: () =>
                        import(
                            /* webpackChunkName: "changefund" */ "@/bizcomponents/fund/transferCombTrusteeIn.vue"
                        ),
                    option: '{"title":"转托管入直销详情","className": "bizcomp-border"}'
                }
            ]
        },
        planCalculator: {
            components: [
                {
                    code: "planCalculator",
                    name: "定投计算器",
                    component: () =>
                        import(
                            /* webpackChunkName: "planCalculator" */ "@/bizcomponents/fund/planCalculator.vue"
                        ),
                    option: '{"title":"定投计算器","className": "bizcomp-border"}'
                }
            ]
        },
        glist: {
            components: [
                {
                    code: "generalFundList",
                    name: "基金定投",
                    component: () =>
                        import(
                            /* webpackChunkName: "generalFundList" */ "@/bizcomponents/fund/fundMarket.vue"
                        ),
                    option: '{"title":"基金定投","className": "bizcomp-border"}'
                }
            ]
        },
        gfund: {
            components: [
                {
                    code: "generalfund",
                    name: "基金定投",
                    component: () =>
                        import(
                            /* webpackChunkName: "generalfund" */ "@/bizcomponents/general/generalFund.vue"
                        ),
                    option: '{"className": "bizcomp-border"}'
                }
            ]
        },
        combogeneral: {
            components: [
                {
                    code: "combogeneral",
                    name: "组合定投",
                    component: () =>
                        import(
                            /* webpackChunkName: "combogeneral" */ "@/bizcomponents/comboPlan/comboGeneral.vue"
                        ),
                    option: '{"title":"组合定投","className": "bizcomp-border"}'
                }
            ]
        },
        optionalgeneral: {
            components: [
                {
                    code: "optionalgeneral",
                    name: "自选组合定投",
                    component: () =>
                        import(
                            /* webpackChunkName: "optionalgeneral" */ "@/bizcomponents/comboPlan/optionalGeneral.vue"
                        ),
                    option: '{"title":"自选组合定投","className": "bizcomp-border"}'
                }
            ]
        },
        generalbuy: {
            components: [
                {
                    code: "generalbuy",
                    name: "新增定投协议",
                    component: () =>
                        import(
                            /* webpackChunkName: "generalbuy" */ "@/bizcomponents/general/generalBuy.vue"
                        ),
                    option: '{"title":"新增定投协议","className": "bizcomp-border"}'
                }
            ]
        },
        generalchange: {
            components: [
                {
                    code: "generalchange",
                    name: "修改定投协议",
                    component: () =>
                        import(
                            /* webpackChunkName: "generalchange" */ "@/bizcomponents/general/generalChange.vue"
                        ),
                    option: '{"title":"修改定投协议","className": "bizcomp-border"}'
                }
            ]
        },
        generalrecovery: {
            components: [
                {
                    code: "generalrecovery",
                    name: "定投恢复",
                    component: () =>
                        import(
                            /* webpackChunkName: "generalrecovery" */ "@/bizcomponents/general/generalRecovery.vue"
                        ),
                    option: '{"title":"定投恢复","className": "bizcomp-border"}'
                }
            ]
        },
        wisdombuy: {
            components: [
                {
                    code: "wisdombuy",
                    name: "智慧定投",
                    component: () =>
                        import(
                            /* webpackChunkName: "wisdombuy" */ "@/bizcomponents/general/wisdomBuy.vue"
                        ),
                    option: '{"title":"智慧定投","className": "bizcomp-border-none"}'
                }
            ]
        },
        myplan: {
            components: [
                {
                    code: "myplan",
                    name: "我的定投",
                    component: () =>
                        import(
                            /* webpackChunkName: "myplan" */ "@/bizcomponents/general/myPlanDc.vue"
                        ),
                    option: '{"title":"我的定投","className": "bizcomp-border"}'
                }
            ]
        },
        plandetail: {
            components: [
                {
                    code: "plandetail",
                    name: "定投计划详情",
                    component: () =>
                        import(
                            /* webpackChunkName: "plandetail" */ "@/bizcomponents/general/planDetailDc.vue"
                        ),
                    option: '{"title":"定投计划详情","className": "bizcomp-border"}'
                }
            ]
        },
        // tradeHistory: {
        //     components: [
        //         {
        //             code: "tradeHistory",
        //             name: "交易记录",
        //             component: () =>
        //                 import(
        //                     /* webpackChunkName: "traderecord" */ "@/bizcomponents/fund/tradeHistory.vue"
        //                 ),
        //             option: '{"title":"交易记录","className": "bizcomp-border"}'
        //         }
        //     ]
        // },
        traderecord: {
            components: [
                {
                    code: "traderecord",
                    name: "交易记录",
                    component: () =>
                        import(
                            /* webpackChunkName: "traderecord" */ "@/bizcomponents/fund/tradeHistory.vue"
                        ),
                    option: '{"title":"交易记录","className": "bizcomp-border"}'
                }
            ]
        },
        quickTrade: {
            components: [
                {
                    code: "quickTrade",
                    name: "快速交易",
                    component: () =>
                        import(
                            /* webpackChunkName: "quickTrade" */ "@/bizcomponents/fund/quickTrade.vue"
                        ),
                    option: '{"title":"快速交易","className": "bizcomp-border"}'
                }
            ]
        },
        dividendInfo: {
            components: [
                {
                    code: "dividendInfo",
                    name: "分红信息明细",
                    component: () =>
                        import(
                            /* webpackChunkName: "dividendInfo" */ "@/bizcomponents/fund/dividendInfo.vue"
                        ),
                    option: '{"title":"分红信息明细","className": "bizcomp-border"}'
                }
            ]
        },
        accountSearch: {
            components: [
                {
                    code: "accountSearch",
                    name: "账户查询",
                    component: () =>
                        import(
                            /* webpackChunkName: "accountSearch" */ "@/bizcomponents/fund/accountSearch.vue"
                        ),
                    option: '{"title":"账户查询","className": "bizcomp-border"}'
                }
            ]
        },
        etflist: {
            components: [
                {
                    code: "etflist",
                    name: "补券信息",
                    component: () =>
                        import(
                            /* webpackChunkName: "etflist" */ "@/bizcomponents/fund/etfList.vue"
                        ),
                    option: '{"title":"补券信息","className": "bizcomp-border"}'
                }
            ]
        },
        profitqry: {
            components: [
                {
                    code: "profitqry",
                    name: "盈亏查询",
                    component: () =>
                        import(
                            /* webpackChunkName: "profitqry" */ "@/bizcomponents/fund/profitQry.vue"
                        ),
                    option: '{"title":"盈亏查询","className": "bizcomp-border"}'
                }
            ]
        },
        private: {
            components: [
                {
                    code: "myprivate",
                    name: "我的专户理财",
                    component: () =>
                        import(
                            /* webpackChunkName: "myprivate" */ "@/bizcomponents/privateFund/myPrivate.vue"
                        ),
                    option: '{"title":"我的专户理财","className": "bizcomp-border"}'
                },
                {
                    code: "privateassets",
                    name: "持有专户理财",
                    component: () =>
                        import(
                            /* webpackChunkName: "privateassets" */ "@/bizcomponents/privateFund/privateAssets.vue"
                        ),
                    option: '{"title":"持有专户理财","className": "bizcomp-border","compCate": "1"}'
                }
            ]
        },
        privatefund: {
            components: [
                {
                    code: "privatehot",
                    name: "专户理财推荐",
                    component: () =>
                        import(
                            /* webpackChunkName: "privatehot" */ "@/bizcomponents/privateFund/privateHot.vue"
                        ),
                    option: '{"title":"专户理财","className": ""}'
                },
                {
                    code: "privatefund",
                    name: "专户理财",
                    component: () =>
                        import(
                            /* webpackChunkName: "privatefund" */ "@/bizcomponents/privateFund/privateFund.vue"
                        ),
                    option: '{"title":"专户理财","className": "bizcomp-border"}'
                }
            ]
        },
        privatebuy: {
            components: [
                {
                    code: "privatebuy",
                    name: "专户理财购买",
                    component: () =>
                        import(
                            /* webpackChunkName: "privatebuy" */ "@/bizcomponents/privateFund/privateBuy.vue"
                        ),
                    option: '{"title":"专户理财购买","className": "bizcomp-border"}'
                }
            ]
        },
        idnumbertran: {
            components: [
                {
                    code: "idnumbertran",
                    name: "身份证号位数转换",
                    component: () =>
                        import(
                            /* webpackChunkName: "idnumbertran" */ "@/bizcomponents/acctManager/idNumberTran.vue"
                        ),
                    option: '{"title":"身份证号位数转换","className": "bizcomp-border"}'
                }
            ]
        },
        privateupload: {
            components: [
                {
                    code: "holdbank",
                    name: "我的银行卡",
                    component: () =>
                        import(/* webpackChunkName: "bank" */ "@/bizcomponents/bank/holdBank.vue"),
                    option: '{"title":"我的银行卡","className": "bizcomp-border"}'
                }
            ]
        },
        signandunsign: {
            components: [
                {
                    code: "signandunsign",
                    name: "签约解约银行卡",
                    component: () =>
                        import(
                            /* webpackChunkName: "signandunsign" */ "@/bizcomponents/bank/signAndUnsign.vue"
                        ),
                    option: '{"title":"签约解约银行卡","className": "bizcomp-border"}'
                }
            ]
        },
        changecard: {
            components: [
                {
                    code: "changecard",
                    name: "换卡",
                    component: () =>
                        import(
                            /* webpackChunkName: "changecard" */ "@/bizcomponents/bank/changeCard.vue"
                        ),
                    option: '{"title":"换卡","className": "bizcomp-border"}'
                }
            ]
        },
        changecardlist: {
            components: [
                {
                    code: "changecardlist",
                    name: "换卡申请记录",
                    component: () =>
                        import(
                            /* webpackChunkName: "changecardlist" */ "@/bizcomponents/bank/changeCardList.vue"
                        ),
                    option: '{"title":"换卡申请记录","className": "bizcomp-border"}'
                }
            ]
        },
        bank: {
            components: [
                {
                    code: "holdbank",
                    name: "我的银行卡",
                    component: () =>
                        import(/* webpackChunkName: "bank" */ "@/bizcomponents/bank/holdBank.vue"),
                    option: '{"title":"我的银行卡","className": "bizcomp-border"}'
                },
                {
                    code: "supportbank",
                    name: "支持银行卡",
                    component: () =>
                        import(
                            /* webpackChunkName: "bank" */ "@/bizcomponents/bank/supportBank.vue"
                        ),
                    option: '{"title":"支持银行卡","className": "bizcomp-border"}'
                }
            ]
        },
        addbank: {
            components: [
                {
                    code: "addbank",
                    name: "新增银行卡",
                    component: () =>
                        import(
                            /* webpackChunkName: "addbank" */ "@/bizcomponents/bank/addBankDc.vue"
                        ),
                    option: '{"title":"新增银行卡","className": "bizcomp-border"}'
                }
            ]
        },
        signbank: {
            components: [
                {
                    code: "signbank",
                    name: "签约银行卡",
                    component: () =>
                        import(
                            /* webpackChunkName: "signbank" */ "@/bizcomponents/bank/signBank.vue"
                        ),
                    option: '{"title":"签约银行卡","className": "bizcomp-border"}'
                }
            ]
        },
        unsignbank: {
            components: [
                {
                    code: "unsignbank",
                    name: "解约银行卡",
                    component: () =>
                        import(
                            /* webpackChunkName: "unsignbank" */ "@/bizcomponents/bank/unSignBank.vue"
                        ),
                    option: '{"title":"解约银行卡","className": "bizcomp-border"}'
                }
            ]
        },
        modifybank: {
            components: [
                {
                    code: "modifybank",
                    name: "修改银行卡",
                    component: () =>
                        import(
                            /* webpackChunkName: "modifybank" */ "@/bizcomponents/bank/modifyBank.vue"
                        ),
                    option: '{"title":"修改银行卡","className": "bizcomp-border"}'
                }
            ]
        },
        changebank: {
            components: [
                {
                    code: "changebank",
                    name: "更换银行卡",
                    component: () =>
                        import(
                            /* webpackChunkName: "changebank" */ "@/bizcomponents/bank/changeBank.vue"
                        ),
                    option: '{"title":"更换银行卡","className": "bizcomp-border"}'
                }
            ]
        },
        activebank: {
            components: [
                {
                    code: "activebank",
                    name: "激活银行卡",
                    component: () =>
                        import(
                            /* webpackChunkName: "activebank" */ "@/bizcomponents/bank/activeBank.vue"
                        ),
                    option: '{"title":"激活银行卡","className": "bizcomp-border"}'
                }
            ]
        },
        changeqpwd: {
            components: [
                {
                    code: "changeqpwd",
                    name: "修改查询密码",
                    component: () =>
                        import(
                            /* webpackChunkName: "changeqpwd" */ "@/bizcomponents/acctManager/changeQPwd.vue"
                        ),
                    option: '{"title":"修改查询密码","className": "bizcomp-border"}'
                }
            ]
        },
        changelpwd: {
            components: [
                {
                    code: "changelpwd",
                    name: "修改登录密码",
                    component: () =>
                        import(
                            /* webpackChunkName: "changelpwd" */ "@/bizcomponents/acctManager/changeLPwdDc.vue"
                        ),
                    option: '{"title":"修改登录密码","className": "bizcomp-border"}'
                }
            ]
        },
        changetpwd: {
            components: [
                {
                    code: "changetpwd",
                    name: "修改交易密码",
                    component: () =>
                        import(
                            /* webpackChunkName: "changetpwd" */ "@/bizcomponents/acctManager/changeTPwdDc.vue"
                        ),
                    option: '{"title":"修改交易密码","className": "bizcomp-border"}'
                }
            ]
        },
        bindacctway: {
            components: [
                {
                    code: "bindacctway",
                    name: "绑定交易账户",
                    component: () =>
                        import(
                            /* webpackChunkName: "bindacctway" */ "@/bizcomponents/acctManager/bindAcctWay.vue"
                        ),
                    option: '{"title":"绑定交易账户","className": "bizcomp-border"}'
                }
            ]
        },
        bindoldacct: {
            components: [
                {
                    code: "bindoldacct",
                    name: "绑定已有交易账户",
                    component: () =>
                        import(
                            /* webpackChunkName: "bindoldacct" */ "@/bizcomponents/acctManager/bindOldAcct.vue"
                        ),
                    option: '{"title":"绑定已有交易账户","className": "bizcomp-border"}'
                }
            ]
        },
        bindnewacct: {
            components: [
                {
                    code: "bindnewacct",
                    name: "绑定新开交易账户",
                    component: () =>
                        import(
                            /* webpackChunkName: "bindnewacct" */ "@/bizcomponents/acctManager/bindNewAcctDc.vue"
                        ),
                    option: '{"title":"绑定新开交易账户","className": "bizcomp-border"}'
                }
            ]
        },
        bindmobile: {
            components: [
                {
                    code: "bindmobile",
                    name: "手机号绑定",
                    component: () =>
                        import(
                            /* webpackChunkName: "bindmobile" */ "@/bizcomponents/acctManager/bindMobile.vue"
                        ),
                    option: '{"title":"手机号绑定","className": "bizcomp-border"}'
                }
            ]
        },
        checkmobile: {
            components: [
                {
                    code: "checkmobile",
                    name: "手机号检查",
                    component: () =>
                        import(
                            /* webpackChunkName: "bindmobile" */ "@/bizcomponents/acctManager/checkMobile.vue"
                        ),
                    option: '{"title":"手机号检查","className": "bizcomp-border"}'
                }
            ]
        },
        changemobile: {
            components: [
                {
                    code: "changemobile",
                    name: "手机号修改",
                    component: () =>
                        import(
                            /* webpackChunkName: "bindmobile" */ "@/bizcomponents/acctManager/changeMobileDc.vue"
                        ),
                    option: '{"title":"手机号修改","className": "bizcomp-border"}'
                }
            ]
        },
        sdxtext: {
            components: [
                {
                    code: "sdxtext",
                    name: "证券期货投资者适当性管理办法",
                    component: () =>
                        import(/* webpackChunkName: "sdxtext" */ "@/components/form/sdxText.vue"),
                    option: '{"title":"证券期货投资者适当性管理办法","className": "bizcomp-border"}'
                }
            ]
        },
        wxbind: {
            components: [
                {
                    code: "wxbind",
                    name: "微信绑定",
                    component: () =>
                        import(
                            /* webpackChunkName: "wxbind" */ "@/bizcomponents/beforeLogin/wxBind.vue"
                        ),
                    option: '{"title":"微信绑定","className": "bizcomp-border"}'
                }
            ]
        },
        errgeneral: {
            components: [
                {
                    code: "errgeneral",
                    name: "一般错误",
                    component: () =>
                        import(/* webpackChunkName: "err" */ "@/views/common/errGeneral.vue"),
                    option: ""
                }
            ]
        },
        errnetwork: {
            components: [
                {
                    code: "errnetwork",
                    name: "网络错误",
                    component: () =>
                        import(/* webpackChunkName: "err" */ "@/views/common/errNetwork.vue"),
                    option: ""
                }
            ]
        },
        agreement: {
            components: [
                {
                    code: "agreement",
                    name: "协议列表",
                    component: () =>
                        import(
                            /* webpackChunkName: "signandunsign" */ "@/bizcomponents/acctManager/agreementList.vue"
                        ),
                    option: ""
                }
            ]
        },
        contract: {
            components: [
                {
                    code: "contract",
                    name: "合同列表",
                    component: () =>
                        import(
                            /* webpackChunkName: "signandunsign" */ "@/bizcomponents/acctManager/contractList.vue"
                        ),
                    option: ""
                }
            ]
        }
    }
};
export default conf;
